// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

export default styled<any, Theme>('section')`
  flex-grow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  overflow-y: auto;
  padding: 0 2rem;
`;
